// extracted by mini-css-extract-plugin
export default {"container":"WagerBonuses_container--Hmu","expandIcon":"WagerBonuses_expandIcon--j7b"};